import { useEffect, useState } from "react";
import { CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

export interface CommandAction {
  id: string;
  label: string;
  group?: string;
  perform: () => void;
}

export interface CommandPaletteProps {
  actions: readonly CommandAction[];
}

export function CommandPalette({ actions }: CommandPaletteProps) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setOpen((o) => !o);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  // Manual reduce instead of Map.groupBy (ES2024) to keep ES2023 lib compatibility.
  const groups = actions.reduce<Map<string, CommandAction[]>>((map, action) => {
    const key = action.group ?? "General";
    const existing = map.get(key);
    if (existing) {
      existing.push(action);
    } else {
      map.set(key, [action]);
    }
    return map;
  }, new Map<string, CommandAction[]>());

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Type a command or search..." />
      <CommandList>
        <CommandEmpty>No results.</CommandEmpty>
        {[...groups.entries()].map(([heading, items]) => (
          <CommandGroup key={heading} heading={heading}>
            {items.map((a) => (
              <CommandItem key={a.id} onSelect={() => { setOpen(false); a.perform(); }}>
                {a.label}
              </CommandItem>
            ))}
          </CommandGroup>
        ))}
      </CommandList>
    </CommandDialog>
  );
}
